/**
 * Inyecta el script de Google Analytics (gtag.js) en el DOM si no existe aún
 * y registra un page_view.
 * @param {string} measurementId El ID de medición de Google Analytics (ej. G-XXXXXXX)
 */
export const initGoogleAnalytics = (measurementId) => {
    if (!measurementId) return;

    // Verificar si ya existe el script de gtag para este measurementId
    if (document.getElementById(`ga-script-${measurementId}`)) {
        return;
    }

    console.log(`[Google Analytics] Iniciando seguimiento para ID: ${measurementId}`);

    // 1. Inyectar gtag.js asíncrono
    const script = document.createElement('script');
    script.id = `ga-script-${measurementId}`;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // 2. Inyectar el código de inicialización de la capa de datos
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}', {
            page_path: window.location.pathname,
        });
    `;
    document.head.appendChild(inlineScript);
};
